import { useMutation } from '@apollo/client';
import { loader } from 'graphql.macro';

const add = loader('./participant.add.graphql');
const archive = loader('./participant.delete.graphql');

export const useParticipantMutations = () => {
  const [addParticipantMutation] = useMutation(add);
  const [deleteParticipantMutation] = useMutation(archive);
  const deleteParticipant = async ({ userId, parentId, parentModel }) => {
    await deleteParticipantMutation({
      variables: { userId, parentId, parentModel },
    });
  };

  const addParticipant = async (variables) => {
    await addParticipantMutation({
      variables: { ...variables },
    });
  };

  return { addParticipant, deleteParticipant };
};
